import { getCurrentInstance } from "vue";
export function useBannerHelpers() {
    const instance = getCurrentInstance();
    function showBannerConditionally(index, tableName) {
        // index starts from 0
        if (index === 0)
            return false;
        switch (instance.proxy.$federation.countryCode) {
            case "NO":
                switch (tableName) {
                    case "events":
                        // This makes banners appear after 5th row and rest after 7th
                        return (index + 5) % 7 === 0;
                    case "people":
                    case "horses":
                    case "organisations":
                        // This makes banners appear after 4th row and rest after 7th
                        return (index + 4) % 7 === 0;
                    default:
                        return index % 7 === 0;
                }
            default:
                return index % 10 === 0;
        }
    }
    return {
        showBannerConditionally
    };
}
